import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { client } from './src/apollo';

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
);

console.log("gatsby-browser is working!");
